<template>
  <div v-if="variants.v1 === variant"
    class="pxp-cover pt-100 mb-200 tw-max-h-[418px]"
    :style="`background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${vars.backgroundImage});
        background-position: 50% 60%; `"
  >
    <lazy-library-title tag="h2" :text="vars.titleText" class="tw-text-center tw-text-white"></lazy-library-title>
    <div class="container-fluid pxp-props-carousel-right tw-pb-4">
      <div class="tw-mt-16">
        <div class="pxp-areas-carousel testimonial-slider">
          <div class="pxp-areas-carousel-stage testimonial-carousel-stage owl-carousel">
            <div
              v-for="(testimonial, testimonialIndex) in testimonials"
              :key="`testimonial-${testimonialIndex}`"
              class="pxp-areas-carousel-item tw-mb-4 !tw-flex tw-h-[424px] tw-w-[350px] tw-flex-col tw-gap-8 tw-rounded-md tw-px-6 tw-py-7 tw-shadow-[8px_4px_12px_1px_rgba(0,0,0,0.1)] md:tw-w-[420px] lg:tw-h-[365px]"
              :style="`background-color: var(--${vars.cardBackgroundColor})`"
            >
              <div>
                <span
                  v-for="i in testimonial.star"
                  :key="`star-${i}`"
                  class="fa fa-star tw-mr-1"
                  :style="`color: var(--camel)`"
                ></span>
              </div>
              <div>
                <h3 class="font-arial-bold tw-mb-2">{{ testimonial.title }}</h3>
                <p class="font-arial tw-line-clamp-[7] tw-truncate" style="white-space: unset">
                  {{ testimonial.description }}
                </p>
              </div>
              <h3 class="font-arial-bold tw-mt-auto">
                {{ testimonial.author }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




   <div v-if="variants.v2=== variant"
    class="pxp-cover pt-100 mb-200 tw-max-h-[418px]"
    :style="`background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${vars.backgroundImage});
        background-position: 50% 60%; `"
  >
    <lazy-library-title tag="h2" :text="vars.titleText" class="tw-text-center tw-text-white"></lazy-library-title>
    <div class="container-fluid pxp-props-carousel-right tw-pb-4">
      <div class="tw-mt-16">
        <div class="pxp-areas-carousel testimonial-slider">
          <div class="pxp-areas-carousel-stage testimonial-carousel-stage owl-carousel">
            <div
              v-for="(testimonial, testimonialIndex) in testimonials"
              :key="`testimonial-${testimonialIndex}`"
              class="pxp-areas-carousel-item tw-mb-4 !tw-flex tw-h-[424px] tw-w-[350px] tw-flex-col tw-gap-8 tw-rounded-md tw-px-6 tw-py-7 tw-shadow-[8px_4px_12px_1px_rgba(0,0,0,0.1)] md:tw-w-[420px] lg:tw-h-[365px]"
              :style="`background-color: var(--${vars.cardBackgroundColor})`"
            >
             <div style="display: flex; align-items: center;">
 
  
  <svg class="tw-mr-4" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: -32px; vertical-align: start;">
    <g clip-path="url(#clip0_170_550)">
      <path d="M8.35909 0.788944C5.96112 1.62082 3.89311 3.19976 2.45882 5.29382C1.02454 7.38789 0.299573 9.88671 0.390418 12.4233C0.481264 14.9598 1.38313 17.4004 2.96355 19.3864C4.54396 21.3725 6.71962 22.7995 9.17096 23.4577C11.1583 23.9705 13.2405 23.993 15.2385 23.5233C17.0484 23.1168 18.7218 22.2471 20.0947 20.9996C21.5236 19.6615 22.5608 17.9592 23.0947 16.0758C23.6751 14.0277 23.7783 11.8738 23.3966 9.77957H12.2366V14.4089H18.6997C18.5705 15.1473 18.2937 15.852 17.8859 16.4809C17.478 17.1098 16.9474 17.6499 16.326 18.0689C15.5367 18.591 14.6471 18.9423 13.7141 19.1002C12.7784 19.2742 11.8186 19.2742 10.8828 19.1002C9.93444 18.9041 9.03727 18.5127 8.24846 17.9508C6.98124 17.0538 6.02973 15.7794 5.52971 14.3096C5.02124 12.8122 5.02124 11.1888 5.52971 9.69144C5.88564 8.64185 6.47403 7.6862 7.25096 6.89582C8.14007 5.97472 9.26571 5.31631 10.5044 4.99284C11.743 4.66936 13.0469 4.69331 14.2728 5.06207C15.2305 5.35605 16.1063 5.8697 16.8303 6.56207C17.5591 5.83707 18.2866 5.11019 19.0128 4.38144C19.3878 3.98957 19.7966 3.61644 20.166 3.21519C19.0608 2.18671 17.7635 1.38643 16.3485 0.860194C13.7717 -0.0754498 10.9522 -0.100594 8.35909 0.788944Z" fill="white"/>
      <path d="M8.35875 0.789855C10.9516 -0.100288 13.7711 -0.0758051 16.3481 0.85923C17.7634 1.38904 19.0601 2.19318 20.1637 3.22548C19.7887 3.62673 19.3931 4.00173 19.0106 4.39173C18.2831 5.11798 17.5562 5.84173 16.83 6.56298C16.106 5.87061 15.2302 5.35696 14.2725 5.06298C13.047 4.69293 11.7432 4.66759 10.5042 4.98975C9.26516 5.3119 8.13883 5.9691 7.24875 6.88923C6.47181 7.67961 5.88342 8.63526 5.5275 9.68486L1.64062 6.67548C3.03189 3.91653 5.44078 1.80615 8.35875 0.789855Z" fill="#E33629"/>
      <path d="M0.607495 9.65605C0.816409 8.62067 1.16325 7.61798 1.63874 6.6748L5.52562 9.69168C5.01715 11.1891 5.01715 12.8124 5.52562 14.3098C4.23062 15.3098 2.93499 16.3148 1.63874 17.3248C0.448402 14.9554 0.0853684 12.2557 0.607495 9.65605Z" fill="#F8BD00"/>
      <path d="M12.2352 9.77832H23.3952C23.777 11.8726 23.6737 14.0264 23.0933 16.0746C22.5594 17.958 21.5222 19.6602 20.0933 20.9983C18.839 20.0196 17.579 19.0483 16.3246 18.0696C16.9465 17.6501 17.4773 17.1094 17.8852 16.4798C18.2931 15.8503 18.5696 15.1448 18.6983 14.4058H12.2352C12.2333 12.8646 12.2352 11.3214 12.2352 9.77832Z" fill="#587DBD"/>
      <path d="M1.64062 17.3246C2.93687 16.3246 4.2325 15.3196 5.5275 14.3096C6.02851 15.7799 6.98138 17.0544 8.25 17.9508C9.04127 18.5101 9.94037 18.8983 10.89 19.0908C11.8257 19.2648 12.7855 19.2648 13.7213 19.0908C14.6542 18.9329 15.5439 18.5816 16.3331 18.0596C17.5875 19.0383 18.8475 20.0096 20.1019 20.9883C18.7292 22.2366 17.0558 23.1068 15.2456 23.5139C13.2476 23.9836 11.1655 23.9611 9.17813 23.4483C7.60632 23.0286 6.13814 22.2888 4.86563 21.2752C3.51874 20.2059 2.41867 18.8583 1.64062 17.3246Z" fill="#319F43"/>
    </g>
    <defs>
      <clipPath id="clip0_170_550">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
   <span
    v-for="i in testimonial.star"
    :key="`star-${i}`"
    class="fa fa-star tw-mr-1"
    :style="`color: #90C73D`"
  ></span>
</div>
              <div>
                <h3 class="font-arial-bold tw-mb-2">{{ testimonial.title }}</h3>
                <p class="font-arial tw-line-clamp-[7] tw-truncate" style="white-space: unset">
                  {{ testimonial.description }}
                </p>
              </div>
              <h3 class="font-arial-bold tw-mt-auto">
                {{ testimonial.author }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { jQuery } from '~/public/theme3/js/custom.js';

export default defineNuxtComponent({
  name: 'Testimonials',

  mixins: [ComponentMixin],

   data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  computed: {
    testimonials() {
      return this.groupedVariables.testimonials;
    },
  },

  mounted() {
    jQuery.testimonialSlider();
  },
});
</script>

<style scoped>
@media screen and (min-width: 1400px) {
  .pxp-props-carousel-right {
    padding-left: calc((100% - 1340px) / 2 + 15px);
  }
}
@media screen and (max-width: 1199px) {
  .pxp-props-carousel-right {
    padding-left: calc((100% - 960px) / 2 + 15px);
  }
}

@media screen and (max-width: 991px) {
  .pxp-props-carousel-right {
    padding-left: calc((100% - 720px) / 2 + 15px);
  }
}

@media screen and (max-width: 767px) {
  .pxp-props-carousel-right {
    padding-left: calc((100% - 540px) / 2 + 15px);
  }
}

@media screen and (max-width: 575px) {
  .pxp-props-carousel-right {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.pxp-areas-carousel {
  padding-left: 0 !important;
}

.pxp-areas-carousel-stage .pxp-areas-carousel-item {
  display: none;
}

.owl-stage .owl-item .pxp-areas-carousel-item {
  display: block;
}

.pxp-areas-carousel {
  padding: 0;
}
</style>
